/**
 * Canonical public origin for any link a customer, lead or tester can receive.
 *
 * `window.location.origin` is deliberately NOT used for these links: a
 * founder copying an invite while signed in on the deployment host would hand
 * out a `*.emergent.host` URL, and to an audience of compliance professionals
 * an unfamiliar domain reads as phishing. The same rule is enforced on the
 * backend in `backend/links.py`.
 */
export const PUBLIC_ORIGIN = "https://web3readyclarity.com";

/** Absolute, customer-safe URL for an in-app path. */
export const publicUrl = (path = "/") =>
  `${PUBLIC_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
